import { render } from "./ListComponent.vue?vue&type=template&id=52a3698b&scoped=true&ts=true"
import script from "./ListComponent.vue?vue&type=script&lang=ts"
export * from "./ListComponent.vue?vue&type=script&lang=ts"

import "./ListComponent.vue?vue&type=style&index=0&id=52a3698b&lang=css&scoped=true"

import exportComponent from "C:\\Users\\Ronnald\\Desktop\\page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a3698b"]])

export default __exports__